import { InputSwitch } from 'primereact/inputswitch'
import { RadioButton } from 'primereact/radiobutton'
import React, { useEffect } from 'react'
import * as myconst from "../../constants/index"
import { Controller, useFormContext } from 'react-hook-form'
import { Checkbox } from 'primereact/checkbox'

interface arr_type {
  value: string;
  label: string;
}

const StepSix = ({ handlePrev, handleNext, goOnFirst, isLinear, goOnLast, methods, setErrorSteps }: any) => {
  const { register, getValues, setValue, watch, formState: { errors }, control, trigger, clearErrors } = useFormContext();
  const getFormErrorMessage = (name: string) => {
    return (
      errors[name] && (
        <small className="p-error">{errors[name]?.message?.toString()}</small>
      )
    )
  }
  const handleNextButton = async () => {
    let isValid: boolean = false;
    isValid = await trigger(['monetization_timing', 'revenue_streams', 'existing_business']);

    if (isValid) {
      handleNext();
    } else {
      const errorFields = Object.keys(errors);
      if (errorFields.length > 0) {
        const errorField = errorFields[0];
        const fieldElement = document.querySelector(`input[name=${errorField}]`);
        if (fieldElement) {
          (fieldElement as HTMLElement)?.focus();
        } else {
          console.warn(`Field with name ${errorField} not found`);
        }
      }
    }
  }
  const finalError = Object.keys(errors).length
  useEffect(() => {
    setErrorSteps(Object.keys(errors).map((keys: string) => (myconst.findStepWhichAreIncomplete(keys))).filter((item, index) => Object.keys(errors).map((keys: string) => (myconst.findStepWhichAreIncomplete(keys))).indexOf(item) === index))
  }, [finalError])
  return (
    <div className='step-preview-wrap'>
      <div className='stepper-main_butter_pie'>
        <div className='stepper-form'>
          <div className='stepper-wrapper'>
            <div className='form-row'>
              <div className='form-col'>
                <label className="form-label fw-bold">Do you want to monetize early or focus on growth first?</label>
                <Controller
                  name="monetization_timing"
                  control={methods.control}
                  rules={{ required: "Please select a category" }}
                  render={({ field }) => (
                    <>
                      {myconst.getRadioOptions('monetization_timing').map((option: arr_type) => (
                        <div
                          key={option.value}
                          className="p-field-radiobutton"
                        >
                          <RadioButton
                            inputId={'monetization_timing'}
                            value={option.value}
                            onChange={(e) => { field.onChange(e.value); clearErrors('monetization_timing') }}
                            checked={field.value === option.value}
                          />
                          <label className="ms-2 c-pointer" onClick={() => { field.onChange(option.value); clearErrors('monetization_timing') }} htmlFor={option.value}>{option.label}</label>
                        </div>
                      ))}
                    </>
                  )}
                />
                {getFormErrorMessage("monetization_timing")}
              </div>
            </div>
            <div className='form-row'>
              <div className='form-col'>
                <label className="form-label fw-bold">Are you interested in ads, brand deals, memberships, or product sales?</label>
                <Controller
                  name="revenue_streams"
                  control={methods.control}
                  rules={{ required: "Please select a topic" }}
                  render={({ field: { value, onChange } }) => (
                    <>
                      {myconst.getCheckboxOptions('revenue_streams').map((option: arr_type) => {
                        // Check if the current option is selected
                        // Ensure value is an array
                        const currentValue = Array.isArray(value) ? value : [];
                        // Check if the current option is selected
                        const isChecked = currentValue.includes(option.value);

                        // Toggle the option in the array
                        const toggleOption = () => {
                          clearErrors("revenue_streams");
                          let updated = [...currentValue];
                          if (updated.includes(option.value)) {
                            updated = updated.filter((v) => v !== option.value);
                          } else {
                            updated.push(option.value);
                          }
                          onChange(updated);
                        };

                        return (
                          <div key={option.value} className="p-field-checkbox">
                            <Checkbox
                              inputId={'revenue_streams'}
                              value={option.value}
                              checked={isChecked}
                              onChange={(e) => {
                                clearErrors('revenue_streams')
                                // If checked, add the value to the array; otherwise, remove it
                                let updated = [...value];
                                if (e.checked) {
                                  updated.push(option.value);
                                } else {
                                  updated = updated.filter((v) => v !== option.value);
                                }
                                onChange(updated);
                              }}
                            />
                            <label className="ms-2 c-pointer" onClick={toggleOption} htmlFor={option.value} style={{ marginLeft: "0.5rem" }}>
                              {option.label}
                            </label>
                          </div>
                        );
                      })}
                    </>
                  )}
                />
                {getFormErrorMessage("revenue_streams")}
              </div>
            </div>
            <div className="form-row">
              <div className="form-col">
                <label className="form-label fw-bold">Do you have an existing business or product you want to promote?</label>
                <Controller
                  name="existing_business"
                  control={methods.control}
                  // rules={{ required: "Please select a category" }}
                  render={({ field }) => (
                    <>
                      {myconst.getRadioOptions('existing_business').map((option: arr_type) => (
                        <div
                          key={option.value}
                          className="p-field-radiobutton"
                        >
                          <RadioButton
                            inputId={'existing_business'}
                            value={option.value}
                            onChange={(e) => { field.onChange(e.value); clearErrors('existing_business') }}
                            checked={field.value === option.value}
                          />
                          <label className="ms-2 c-pointer" onClick={() => { field.onChange(option.value); clearErrors('existing_business') }} htmlFor={option.value}>{option.label}</label>
                        </div>
                      ))}
                    </>
                  )}
                />
                {getFormErrorMessage("existing_business")}
              </div>
            </div>
          </div>
        </div>
        <div className='stepper-footer'>
          <div className='stepper-wrapper stepper-wrapper-ft ms-auto'>
            <div className='stepper-footer-inner'>
              <div className='stepper-footer-left'>
                <button type="button" onClick={goOnFirst} className="grey-outline-btn mr-2">{'<< First'}</button>
                <button type="button" onClick={handlePrev} className="outline-active-btn">{'< Previous'}</button>
              </div>
              <div className='stepper-footer-right'>
                <button type="button" className="outline-active-btn mr-2" onClick={handleNextButton}>{'Next >'}</button>
                <button type="button" disabled={!isLinear} className="grey-outline-btn" onClick={goOnLast}>{'Last >>'}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StepSix